import NotificationsService from '@/store/services/notifications/notification-service';

const defaultMeta = {
    total: 0,
    current_page: 1,
    last_page: 1,
    per_page: 10
};

const state = {
    items: [],
    meta: { ...defaultMeta },
    count:0,
    loading: false
};

const getters = {
    items: state => state.items,

    meta: state => state.meta,

    count: state => state.count,

    currentPage: state => state.meta.current_page,

    lastPage: state => state.meta.last_page,

    perPage: state => state.meta.per_page,

    loading: state => state.loading
};

const actions = {
    async pending({ commit }, params = {}) {
        const response = await NotificationsService.pending(params);

        commit('SET_ITEMS', {
            items: response.items || [],
            meta: response.meta || defaultMeta
        });
        return response;
    },

    async count({ commit }, params = {}) {
        try {
            const response = await NotificationsService.count(params);

            commit('SET_COUNT', response.count || 0);
        } catch (e) {
            commit('SET_COUNT', 0);
        }
    }
};

const mutations = {
    SET_ITEMS(state, payload) {
        state.items = payload.items || [];
        state.meta = payload.meta || defaultMeta;
    },

    SET_COUNT(state, count) {
        state.count = count;
    },

    SET_LOADING(state, status) {
        state.loading = status;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
